import { render } from "./AppContactBox.vue?vue&type=template&id=b42c0abe&scoped=true"
import script from "./AppContactBox.vue?vue&type=script&lang=js"
export * from "./AppContactBox.vue?vue&type=script&lang=js"

import "./AppContactBox.vue?vue&type=style&index=0&id=b42c0abe&lang=scss&scoped=true"

import exportComponent from "/Users/patriksvensson/Documents/Projects/KK/bygdrift/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b42c0abe"]])

export default __exports__